import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Tiny hook that exposes runtime feature flags from the backend.
 * Flags are cached in memory for the session. `affiliatesEnabled` controls
 * whether the helper/affiliate surface area is visible anywhere in the SPA.
 *
 * Iter 155 (May 2026): the Community Partners kill-switch is now code-only —
 * Emergent native production deploys are not reliably propagating the
 * AFFILIATES_ENABLED env var, so the frontend forces `affiliatesEnabled: true`
 * regardless of the backend response. To disable affiliates, flip this constant
 * to `false` and redeploy.
 */
let _cache = null;
let _inflight = null;

const DEFAULTS = { affiliatesEnabled: true, freeTrialEnabled: false };

// Force affiliatesEnabled to always be true — see Iter 155 note above.
const FORCE_AFFILIATES_ENABLED = true;

export const useFlags = () => {
  const [flags, setFlags] = useState(_cache || { ...DEFAULTS, _loaded: !!_cache });
  useEffect(() => {
    if (_cache) { setFlags({ ..._cache, _loaded: true }); return; }
    if (!_inflight) {
      _inflight = axios.get(`${API}/api/flags`).then(
        (r) => { _cache = { ...DEFAULTS, ...(r.data || {}), affiliatesEnabled: FORCE_AFFILIATES_ENABLED }; return _cache; },
        () => { _cache = { ...DEFAULTS }; return _cache; },
      );
    }
    _inflight.then((data) => setFlags({ ...data, _loaded: true }));
  }, []);
  return flags;
};

export const getCachedFlags = () => _cache || { ...DEFAULTS };
